/* eslint-disable import/prefer-default-export */
// using named exports since individual page scripts will most likely only
// use the set method
const GLOBAL_DATA_STORE_KEY = '__sk_global_datastore';

window[GLOBAL_DATA_STORE_KEY] = window[GLOBAL_DATA_STORE_KEY] || {};

export function getGlobalDatastoreValue(key) {
  return window[GLOBAL_DATA_STORE_KEY][key];
}

export function setGlobalDatastoreValue(key, value) {
  window[GLOBAL_DATA_STORE_KEY][key] = value;
}
